export * from '../models/AnalyzeSqlQueryRequest.js';
export * from '../models/AwsCredentialProfile.js';
export * from '../models/AwsCredentialProfileInput.js';
export * from '../models/AwsLoggingSettings.js';
export * from '../models/AwsLoggingSettingsInput.js';
export * from '../models/AwsMetricsSettings.js';
export * from '../models/AwsMetricsSettingsInput.js';
export * from '../models/AwsNetworkingSettings.js';
export * from '../models/AwsNetworkingSettingsVpcPeering.js';
export * from '../models/AwsPrincipal.js';
export * from '../models/AwsPrincipalInput.js';
export * from '../models/AwsPrivateLink.js';
export * from '../models/AwsSecretsManagerRef.js';
export * from '../models/AwsSecretsManagerRefInput.js';
export * from '../models/AwsStorageAccessConfigurationInput.js';
export * from '../models/AwsVpcPeering.js';
export * from '../models/AwsWorkspaceInfo.js';
export * from '../models/BatchMode.js';
export * from '../models/BiglakeCatalogProperties.js';
export * from '../models/BucketFileCompression.js';
export * from '../models/BucketFileFormat.js';
export * from '../models/BucketFileProbeRequest.js';
export * from '../models/BucketFileProbeResponse.js';
export * from '../models/BucketFilesMode.js';
export * from '../models/BucketFilesSourceProperties.js';
export * from '../models/BucketNotificationProbeRequest.js';
export * from '../models/BucketNotificationProbeResponse.js';
export * from '../models/BucketNotificationTransport.js';
export * from '../models/BucketPathPartitionSpec.js';
export * from '../models/CatalogAccessRequest.js';
export * from '../models/CatalogAccessResponse.js';
export * from '../models/CatalogCheckNameRequest.js';
export * from '../models/CatalogCheckNameResponse.js';
export * from '../models/CatalogDatabase.js';
export * from '../models/CatalogListDatabasesRequest.js';
export * from '../models/CatalogListDatabasesResponse.js';
export * from '../models/CloudPrincipal.js';
export * from '../models/CloudPrincipalAws.js';
export * from '../models/CloudPrincipalGcp.js';
export * from '../models/CloudPrincipalInput.js';
export * from '../models/CloudPrincipalInputAws.js';
export * from '../models/CloudPrincipalInputGcp.js';
export * from '../models/CompactionStrategy.js';
export * from '../models/Condition.js';
export * from '../models/CreateAwsPrivateLinkInput.js';
export * from '../models/CreateAwsVpcPeeringInput.js';
export * from '../models/CreateCredentialsProfileInput.js';
export * from '../models/CreateDashboardInput.js';
export * from '../models/CreateDataCatalogInput.js';
export * from '../models/CreateDataCatalogInputIcebergRestProperties.js';
export * from '../models/CreateGcpVpcPeeringInput.js';
export * from '../models/CreateGraphInput.js';
export * from '../models/CreateIngestionPipelineInput.js';
export * from '../models/CreateJobTemplateInput.js';
export * from '../models/CreateNotebookInput.js';
export * from '../models/CreatePscEndpointInput.js';
export * from '../models/CreateSavedQueryInput.js';
export * from '../models/CreateSparkEngineInput.js';
export * from '../models/CreateSqlEngineInput.js';
export * from '../models/CreateZeroEtlPolicyInput.js';
export * from '../models/CredentialsProbeAssumeResponse.js';
export * from '../models/CredentialsProbeWriteResponse.js';
export * from '../models/CredentialsProfile.js';
export * from '../models/CredentialsProfileAws.js';
export * from '../models/CredentialsProfileGcp.js';
export * from '../models/Dashboard.js';
export * from '../models/DashboardGraph.js';
export * from '../models/DashboardGraphLayout.js';
export * from '../models/DashboardWithGraphs.js';
export * from '../models/DataCatalog.js';
export * from '../models/DataCatalogBiglakeProperties.js';
export * from '../models/DataCatalogGlueProperties.js';
export * from '../models/DataCatalogIcebergRestProperties.js';
export * from '../models/DataCatalogType.js';
export * from '../models/DetectedFormat.js';
export * from '../models/DetectedFormatType.js';
export * from '../models/EonSparkVersion.js';
export * from '../models/ErrorPolicy.js';
export * from '../models/ExecuteNotebookCodeInput.js';
export * from '../models/FieldOverride.js';
export * from '../models/FieldOverrideOnError.js';
export * from '../models/FieldOverrideTargetType.js';
export * from '../models/FileFormat.js';
export * from '../models/FlinkDeploymentObservation.js';
export * from '../models/GcpCredentialProfile.js';
export * from '../models/GcpCredentialProfileInput.js';
export * from '../models/GcpLoggingSettings.js';
export * from '../models/GcpLoggingSettingsInput.js';
export * from '../models/GcpMetricsSettings.js';
export * from '../models/GcpMetricsSettingsInput.js';
export * from '../models/GcpNetworkingSettings.js';
export * from '../models/GcpNetworkingSettingsVpcPeering.js';
export * from '../models/GcpPrincipal.js';
export * from '../models/GcpPrincipalInput.js';
export * from '../models/GcpSecretManagerRef.js';
export * from '../models/GcpSecretManagerRefInput.js';
export * from '../models/GcpStorageAccessConfigurationInput.js';
export * from '../models/GcpVpcPeering.js';
export * from '../models/GcpWorkspaceInfo.js';
export * from '../models/GcsListPrefixesRequest.js';
export * from '../models/GcsListPrefixesResponse.js';
export * from '../models/GcsSampleObject.js';
export * from '../models/GcsSourceProperties.js';
export * from '../models/GetNotebookContent200Response.js';
export * from '../models/GlueCatalogProperties.js';
export * from '../models/IcebergCompactionConfig.js';
export * from '../models/IcebergRestCatalogAuthType.js';
export * from '../models/IcebergRestCatalogProperties.js';
export * from '../models/IcebergRestCatalogPropertiesCredentialsSecret.js';
export * from '../models/IcebergRestCatalogPropertiesInput.js';
export * from '../models/IcebergRestCatalogPropertiesInputCredentialsSecret.js';
export * from '../models/IcebergSinkProperties.js';
export * from '../models/IngestionComputeSize.js';
export * from '../models/IngestionPipeline.js';
export * from '../models/IngestionPipelineLastObservation.js';
export * from '../models/IngestionPipelineMetrics.js';
export * from '../models/IngestionPipelineMetricsRange.js';
export * from '../models/IngestionPipelineObservation.js';
export * from '../models/IngestionPipelineObservationFlinkDeployment.js';
export * from '../models/IngestionPipelineStatus.js';
export * from '../models/IngestionSinkType.js';
export * from '../models/IngestionSourceType.js';
export * from '../models/JobTemplate.js';
export * from '../models/JobTemplateRetryPolicy.js';
export * from '../models/JsonPathSample.js';
export * from '../models/K8sEventObservation.js';
export * from '../models/KafkaBatchConfig.js';
export * from '../models/KafkaConnectProbeRequest.js';
export * from '../models/KafkaConnectProbeResponse.js';
export * from '../models/KafkaErrorHandlingConfig.js';
export * from '../models/KafkaInferSchemaRequest.js';
export * from '../models/KafkaInferSchemaResponse.js';
export * from '../models/KafkaKeyHandling.js';
export * from '../models/KafkaMessageFormat.js';
export * from '../models/KafkaMessageSample.js';
export * from '../models/KafkaOffsetStrategy.js';
export * from '../models/KafkaPartitioningConfig.js';
export * from '../models/KafkaSampleProbeRequest.js';
export * from '../models/KafkaSampleProbeResponse.js';
export * from '../models/KafkaSaslMechanism.js';
export * from '../models/KafkaSchemaOverridesConfig.js';
export * from '../models/KafkaSecretProbeRequest.js';
export * from '../models/KafkaSecretProbeResponse.js';
export * from '../models/KafkaSecurityConfig.js';
export * from '../models/KafkaSecurityConfigCredentialsSecret.js';
export * from '../models/KafkaSecurityConfigInput.js';
export * from '../models/KafkaSecurityConfigInputCredentialsSecret.js';
export * from '../models/KafkaSecurityConfigInputTlsSecret.js';
export * from '../models/KafkaSecurityConfigTlsSecret.js';
export * from '../models/KafkaSecurityProtocol.js';
export * from '../models/KafkaSourceConfig.js';
export * from '../models/KafkaSourceProperties.js';
export * from '../models/KafkaSourcePropertiesInput.js';
export * from '../models/KafkaStartingOffset.js';
export * from '../models/KafkaTopicInfo.js';
export * from '../models/KafkaTopicsProbeRequest.js';
export * from '../models/KafkaTopicsProbeResponse.js';
export * from '../models/ListCredentialsProfilesResponse.js';
export * from '../models/ListDashboardsResponse.js';
export * from '../models/ListDataCatalogsResponse.js';
export * from '../models/ListGraphsResponse.js';
export * from '../models/ListIngestionPipelinesResponse.js';
export * from '../models/ListJobTemplatesResponse.js';
export * from '../models/ListNotebooksResponse.js';
export * from '../models/ListSavedQueriesResponse.js';
export * from '../models/ListSparkEnginesResponse.js';
export * from '../models/ListSparkJobsResponse.js';
export * from '../models/ListSqlEnginesResponse.js';
export * from '../models/ListSqlQueryExecutionsResponse.js';
export * from '../models/ListTableMaintenanceRunsRequest.js';
export * from '../models/ListTableMaintenanceRunsResponse.js';
export * from '../models/ListZeroEtlPoliciesResponse.js';
export * from '../models/LooksLike.js';
export * from '../models/MaintenanceRun.js';
export * from '../models/MaintenanceRunStatus.js';
export * from '../models/MaintenanceRunType.js';
export * from '../models/MetricTimeseries.js';
export * from '../models/MetricTimeseriesPoint.js';
export * from '../models/Notebook.js';
export * from '../models/NotebookExecutionOutput.js';
export * from '../models/NotebookExecutionResult.js';
export * from '../models/NotebookSession.js';
export * from '../models/NotebookSessionStatus.js';
export * from '../models/NotificationMessageMapping.js';
export * from '../models/OverrideParseResult.js';
export * from '../models/OverrideSampleExample.js';
export * from '../models/Pagination.js';
export * from '../models/PaimonClusteringStrategy.js';
export * from '../models/PaimonRestAuthMode.js';
export * from '../models/PaimonRestCatalogConfig.js';
export * from '../models/PaimonSinkProperties.js';
export * from '../models/ParsedValue.js';
export * from '../models/PartitionCandidate.js';
export * from '../models/PartitionField.js';
export * from '../models/PartitionFormat.js';
export * from '../models/PartitionSegmentType.js';
export * from '../models/PartitionTransform.js';
export * from '../models/PartitionType.js';
export * from '../models/PathPartitionsTimestamp.js';
export * from '../models/PathPartitionsTimestampGranularity.js';
export * from '../models/PathSegment.js';
export * from '../models/PodObservation.js';
export * from '../models/PollingConfig.js';
export * from '../models/PrivateLinkStatus.js';
export * from '../models/ProbeError.js';
export * from '../models/ProbeErrorCode.js';
export * from '../models/PscEndpoint.js';
export * from '../models/S3DetectPartitionsRequest.js';
export * from '../models/S3DetectPartitionsResponse.js';
export * from '../models/S3FileSampleStats.js';
export * from '../models/S3ListPrefixesRequest.js';
export * from '../models/S3ListPrefixesResponse.js';
export * from '../models/S3PartitionLayout.js';
export * from '../models/S3SampleFileRequest.js';
export * from '../models/S3SampleFileResponse.js';
export * from '../models/S3SampleObject.js';
export * from '../models/S3SourceProperties.js';
export * from '../models/SaslSecretProbe.js';
export * from '../models/SaveNotebookContentRequest.js';
export * from '../models/SavedQuery.js';
export * from '../models/SchemaEvolutionMode.js';
export * from '../models/SchemaField.js';
export * from '../models/SchemaReference.js';
export * from '../models/SchemaRegistryAuthConfig.js';
export * from '../models/SchemaRegistryAuthConfigInput.js';
export * from '../models/SchemaRegistryAuthType.js';
export * from '../models/SchemaRegistryConfig.js';
export * from '../models/SchemaRegistryConfigInput.js';
export * from '../models/SchemaRegistryConnectRequest.js';
export * from '../models/SchemaRegistryConnectResponse.js';
export * from '../models/SchemaRegistryResolveSubjectRequest.js';
export * from '../models/SchemaRegistryResolveSubjectResponse.js';
export * from '../models/SchemaRegistrySchemaByIdRequest.js';
export * from '../models/SchemaRegistrySchemaRequest.js';
export * from '../models/SchemaRegistrySchemaResponse.js';
export * from '../models/SchemaRegistrySubject.js';
export * from '../models/SchemaRegistrySubjectsRequest.js';
export * from '../models/SchemaRegistrySubjectsResponse.js';
export * from '../models/SecretRef.js';
export * from '../models/SecretRefAws.js';
export * from '../models/SecretRefGcp.js';
export * from '../models/SecretRefInput.js';
export * from '../models/SecretRefInputAws.js';
export * from '../models/SecretRefInputGcp.js';
export * from '../models/SecurityGroupRule.js';
export * from '../models/SecurityGroupRuleProtocol.js';
export * from '../models/SegmentType.js';
export * from '../models/SortColumnSpec.js';
export * from '../models/SourceShardByPathPartition.js';
export * from '../models/SparkEngine.js';
export * from '../models/SparkEngineStatus.js';
export * from '../models/SparkJob.js';
export * from '../models/SparkJobRetryPolicy.js';
export * from '../models/SparkJobSparkSubmitParams.js';
export * from '../models/SparkJobStatus.js';
export * from '../models/SparkJobStorageConfig.js';
export * from '../models/SqlEngine.js';
export * from '../models/SqlEngineStatus.js';
export * from '../models/SqlQueryExecution.js';
export * from '../models/SqlQueryExecutionResult.js';
export * from '../models/SqlQueryExecutionResultColumn.js';
export * from '../models/SqlQueryExecutionStatus.js';
export * from '../models/StartNotebookSessionInput.js';
export * from '../models/StartSparkJobDirectParams.js';
export * from '../models/StartSparkJobInput.js';
export * from '../models/StartSparkJobTemplateParams.js';
export * from '../models/StartSqlQueryExecutionInput.js';
export * from '../models/StorageConfig.js';
export * from '../models/SubjectNamingStrategy.js';
export * from '../models/SubjectResolution.js';
export * from '../models/TableMaintenanceConfig.js';
export * from '../models/TableRetentionConfig.js';
export * from '../models/TlsSecretProbe.js';
export * from '../models/UpdateAwsPrivateLinkInput.js';
export * from '../models/UpdateCredentialsProfileInput.js';
export * from '../models/UpdateCredentialsProfileInputAws.js';
export * from '../models/UpdateCredentialsProfileInputGcp.js';
export * from '../models/UpdateDashboardInput.js';
export * from '../models/UpdateGraphInput.js';
export * from '../models/UpdateIngestionPipelineInput.js';
export * from '../models/UpdateJobTemplateInput.js';
export * from '../models/UpdateNotebookInput.js';
export * from '../models/UpdatePscEndpointInput.js';
export * from '../models/UpdateSavedQueryInput.js';
export * from '../models/UpdateTableMaintenanceConfigInput.js';
export * from '../models/UpdateWorkspaceLoggingSettingsInput.js';
export * from '../models/UpdateWorkspaceLoggingSettingsInputAws.js';
export * from '../models/UpdateWorkspaceLoggingSettingsInputGcp.js';
export * from '../models/UpdateWorkspaceMaintenanceSettingsRequest.js';
export * from '../models/UpdateWorkspaceMetricsSettingsInput.js';
export * from '../models/UpdateWorkspaceMetricsSettingsInputAws.js';
export * from '../models/UpdateWorkspaceMetricsSettingsInputGcp.js';
export * from '../models/UpdateWorkspaceStorageAccessConfigurationInput.js';
export * from '../models/UpdateWorkspaceStorageAccessConfigurationInputAws.js';
export * from '../models/UpdateWorkspaceStorageAccessConfigurationInputGcp.js';
export * from '../models/UpdateZeroEtlPolicyInput.js';
export * from '../models/VpcPeeringStatus.js';
export * from '../models/WarmCapacity.js';
export * from '../models/Workspace.js';
export * from '../models/WorkspaceAllowedPrincipal.js';
export * from '../models/WorkspaceAllowedPrincipalInput.js';
export * from '../models/WorkspaceAws.js';
export * from '../models/WorkspaceAwsStorageAccessConfiguration.js';
export * from '../models/WorkspaceGcp.js';
export * from '../models/WorkspaceGcpStorageAccessConfiguration.js';
export * from '../models/WorkspaceLoggingSettings.js';
export * from '../models/WorkspaceLoggingSettingsAws.js';
export * from '../models/WorkspaceLoggingSettingsGcp.js';
export * from '../models/WorkspaceMaintenanceSettings.js';
export * from '../models/WorkspaceMetricsSettings.js';
export * from '../models/WorkspaceMetricsSettingsAws.js';
export * from '../models/WorkspaceMetricsSettingsGcp.js';
export * from '../models/WorkspaceNetworkingSettings.js';
export * from '../models/WorkspaceNetworkingSettingsAws.js';
export * from '../models/WorkspaceNetworkingSettingsGcp.js';
export * from '../models/WorkspaceStatus.js';
export * from '../models/WorkspaceStorageAccessConfiguration.js';
export * from '../models/WorkspaceStorageAccessConfigurationAws.js';
export * from '../models/WorkspaceStorageAccessConfigurationGcp.js';
export * from '../models/WorkspaceStorageAllowedCredentialsProfile.js';
export * from '../models/WorkspaceStorageAllowedCredentialsProfileInput.js';
export * from '../models/WorkspaceStoragePermission.js';
export * from '../models/ZeroEtlIdentityColumnField.js';
export * from '../models/ZeroEtlIdentityColumnSpec.js';
export * from '../models/ZeroEtlPolicy.js';
export * from '../models/ZeroEtlResourceSelector.js';
export * from '../models/ZeroEtlRoutingMode.js';
export * from '../models/ZeroEtlRoutingPolicy.js';
import { AnalyzeSqlQueryRequest } from '../models/AnalyzeSqlQueryRequest.js';
import { AwsCredentialProfile } from '../models/AwsCredentialProfile.js';
import { AwsCredentialProfileInput } from '../models/AwsCredentialProfileInput.js';
import { AwsLoggingSettings } from '../models/AwsLoggingSettings.js';
import { AwsLoggingSettingsInput } from '../models/AwsLoggingSettingsInput.js';
import { AwsMetricsSettings } from '../models/AwsMetricsSettings.js';
import { AwsMetricsSettingsInput } from '../models/AwsMetricsSettingsInput.js';
import { AwsNetworkingSettings } from '../models/AwsNetworkingSettings.js';
import { AwsNetworkingSettingsVpcPeering } from '../models/AwsNetworkingSettingsVpcPeering.js';
import { AwsPrincipal } from '../models/AwsPrincipal.js';
import { AwsPrincipalInput } from '../models/AwsPrincipalInput.js';
import { AwsPrivateLink } from '../models/AwsPrivateLink.js';
import { AwsSecretsManagerRef } from '../models/AwsSecretsManagerRef.js';
import { AwsSecretsManagerRefInput } from '../models/AwsSecretsManagerRefInput.js';
import { AwsStorageAccessConfigurationInput } from '../models/AwsStorageAccessConfigurationInput.js';
import { AwsVpcPeering } from '../models/AwsVpcPeering.js';
import { AwsWorkspaceInfo } from '../models/AwsWorkspaceInfo.js';
import { BiglakeCatalogProperties } from '../models/BiglakeCatalogProperties.js';
import { BucketFileProbeRequest } from '../models/BucketFileProbeRequest.js';
import { BucketFileProbeResponse } from '../models/BucketFileProbeResponse.js';
import { BucketFilesSourceProperties } from '../models/BucketFilesSourceProperties.js';
import { BucketNotificationProbeRequest } from '../models/BucketNotificationProbeRequest.js';
import { BucketNotificationProbeResponse } from '../models/BucketNotificationProbeResponse.js';
import { BucketPathPartitionSpec } from '../models/BucketPathPartitionSpec.js';
import { CatalogAccessRequest } from '../models/CatalogAccessRequest.js';
import { CatalogAccessResponse } from '../models/CatalogAccessResponse.js';
import { CatalogCheckNameRequest } from '../models/CatalogCheckNameRequest.js';
import { CatalogCheckNameResponse } from '../models/CatalogCheckNameResponse.js';
import { CatalogDatabase } from '../models/CatalogDatabase.js';
import { CatalogListDatabasesRequest } from '../models/CatalogListDatabasesRequest.js';
import { CatalogListDatabasesResponse } from '../models/CatalogListDatabasesResponse.js';
import { CloudPrincipal } from '../models/CloudPrincipal.js';
import { CloudPrincipalAws } from '../models/CloudPrincipalAws.js';
import { CloudPrincipalGcp } from '../models/CloudPrincipalGcp.js';
import { CloudPrincipalInput } from '../models/CloudPrincipalInput.js';
import { CloudPrincipalInputAws } from '../models/CloudPrincipalInputAws.js';
import { CloudPrincipalInputGcp } from '../models/CloudPrincipalInputGcp.js';
import { Condition } from '../models/Condition.js';
import { CreateAwsPrivateLinkInput } from '../models/CreateAwsPrivateLinkInput.js';
import { CreateAwsVpcPeeringInput } from '../models/CreateAwsVpcPeeringInput.js';
import { CreateCredentialsProfileInput } from '../models/CreateCredentialsProfileInput.js';
import { CreateDashboardInput } from '../models/CreateDashboardInput.js';
import { CreateDataCatalogInput } from '../models/CreateDataCatalogInput.js';
import { CreateDataCatalogInputIcebergRestProperties } from '../models/CreateDataCatalogInputIcebergRestProperties.js';
import { CreateGcpVpcPeeringInput } from '../models/CreateGcpVpcPeeringInput.js';
import { CreateGraphInput } from '../models/CreateGraphInput.js';
import { CreateIngestionPipelineInput } from '../models/CreateIngestionPipelineInput.js';
import { CreateJobTemplateInput } from '../models/CreateJobTemplateInput.js';
import { CreateNotebookInput } from '../models/CreateNotebookInput.js';
import { CreatePscEndpointInput } from '../models/CreatePscEndpointInput.js';
import { CreateSavedQueryInput } from '../models/CreateSavedQueryInput.js';
import { CreateSparkEngineInput } from '../models/CreateSparkEngineInput.js';
import { CreateSqlEngineInput } from '../models/CreateSqlEngineInput.js';
import { CreateZeroEtlPolicyInput } from '../models/CreateZeroEtlPolicyInput.js';
import { CredentialsProbeAssumeResponse } from '../models/CredentialsProbeAssumeResponse.js';
import { CredentialsProbeWriteResponse } from '../models/CredentialsProbeWriteResponse.js';
import { CredentialsProfile } from '../models/CredentialsProfile.js';
import { CredentialsProfileAws } from '../models/CredentialsProfileAws.js';
import { CredentialsProfileGcp } from '../models/CredentialsProfileGcp.js';
import { Dashboard } from '../models/Dashboard.js';
import { DashboardGraph } from '../models/DashboardGraph.js';
import { DashboardGraphLayout } from '../models/DashboardGraphLayout.js';
import { DashboardWithGraphs } from '../models/DashboardWithGraphs.js';
import { DataCatalog } from '../models/DataCatalog.js';
import { DataCatalogBiglakeProperties } from '../models/DataCatalogBiglakeProperties.js';
import { DataCatalogGlueProperties } from '../models/DataCatalogGlueProperties.js';
import { DataCatalogIcebergRestProperties } from '../models/DataCatalogIcebergRestProperties.js';
import { DetectedFormat } from '../models/DetectedFormat.js';
import { ExecuteNotebookCodeInput } from '../models/ExecuteNotebookCodeInput.js';
import { FieldOverride } from '../models/FieldOverride.js';
import { FlinkDeploymentObservation } from '../models/FlinkDeploymentObservation.js';
import { GcpCredentialProfile } from '../models/GcpCredentialProfile.js';
import { GcpCredentialProfileInput } from '../models/GcpCredentialProfileInput.js';
import { GcpLoggingSettings } from '../models/GcpLoggingSettings.js';
import { GcpLoggingSettingsInput } from '../models/GcpLoggingSettingsInput.js';
import { GcpMetricsSettings } from '../models/GcpMetricsSettings.js';
import { GcpMetricsSettingsInput } from '../models/GcpMetricsSettingsInput.js';
import { GcpNetworkingSettings } from '../models/GcpNetworkingSettings.js';
import { GcpNetworkingSettingsVpcPeering } from '../models/GcpNetworkingSettingsVpcPeering.js';
import { GcpPrincipal } from '../models/GcpPrincipal.js';
import { GcpPrincipalInput } from '../models/GcpPrincipalInput.js';
import { GcpSecretManagerRef } from '../models/GcpSecretManagerRef.js';
import { GcpSecretManagerRefInput } from '../models/GcpSecretManagerRefInput.js';
import { GcpStorageAccessConfigurationInput } from '../models/GcpStorageAccessConfigurationInput.js';
import { GcpVpcPeering } from '../models/GcpVpcPeering.js';
import { GcpWorkspaceInfo } from '../models/GcpWorkspaceInfo.js';
import { GcsListPrefixesRequest } from '../models/GcsListPrefixesRequest.js';
import { GcsListPrefixesResponse } from '../models/GcsListPrefixesResponse.js';
import { GcsSampleObject } from '../models/GcsSampleObject.js';
import { GcsSourceProperties } from '../models/GcsSourceProperties.js';
import { GetNotebookContent200Response } from '../models/GetNotebookContent200Response.js';
import { GlueCatalogProperties } from '../models/GlueCatalogProperties.js';
import { IcebergCompactionConfig } from '../models/IcebergCompactionConfig.js';
import { IcebergRestCatalogProperties } from '../models/IcebergRestCatalogProperties.js';
import { IcebergRestCatalogPropertiesCredentialsSecret } from '../models/IcebergRestCatalogPropertiesCredentialsSecret.js';
import { IcebergRestCatalogPropertiesInput } from '../models/IcebergRestCatalogPropertiesInput.js';
import { IcebergRestCatalogPropertiesInputCredentialsSecret } from '../models/IcebergRestCatalogPropertiesInputCredentialsSecret.js';
import { IcebergSinkProperties } from '../models/IcebergSinkProperties.js';
import { IngestionPipeline } from '../models/IngestionPipeline.js';
import { IngestionPipelineLastObservation } from '../models/IngestionPipelineLastObservation.js';
import { IngestionPipelineMetrics } from '../models/IngestionPipelineMetrics.js';
import { IngestionPipelineMetricsRange } from '../models/IngestionPipelineMetricsRange.js';
import { IngestionPipelineObservation } from '../models/IngestionPipelineObservation.js';
import { IngestionPipelineObservationFlinkDeployment } from '../models/IngestionPipelineObservationFlinkDeployment.js';
import { JobTemplate } from '../models/JobTemplate.js';
import { JobTemplateRetryPolicy } from '../models/JobTemplateRetryPolicy.js';
import { JsonPathSample } from '../models/JsonPathSample.js';
import { K8sEventObservation } from '../models/K8sEventObservation.js';
import { KafkaBatchConfig } from '../models/KafkaBatchConfig.js';
import { KafkaConnectProbeRequest } from '../models/KafkaConnectProbeRequest.js';
import { KafkaConnectProbeResponse } from '../models/KafkaConnectProbeResponse.js';
import { KafkaErrorHandlingConfig } from '../models/KafkaErrorHandlingConfig.js';
import { KafkaInferSchemaRequest } from '../models/KafkaInferSchemaRequest.js';
import { KafkaInferSchemaResponse } from '../models/KafkaInferSchemaResponse.js';
import { KafkaMessageSample } from '../models/KafkaMessageSample.js';
import { KafkaPartitioningConfig } from '../models/KafkaPartitioningConfig.js';
import { KafkaSampleProbeRequest } from '../models/KafkaSampleProbeRequest.js';
import { KafkaSampleProbeResponse } from '../models/KafkaSampleProbeResponse.js';
import { KafkaSchemaOverridesConfig } from '../models/KafkaSchemaOverridesConfig.js';
import { KafkaSecretProbeRequest } from '../models/KafkaSecretProbeRequest.js';
import { KafkaSecretProbeResponse } from '../models/KafkaSecretProbeResponse.js';
import { KafkaSecurityConfig } from '../models/KafkaSecurityConfig.js';
import { KafkaSecurityConfigCredentialsSecret } from '../models/KafkaSecurityConfigCredentialsSecret.js';
import { KafkaSecurityConfigInput } from '../models/KafkaSecurityConfigInput.js';
import { KafkaSecurityConfigInputCredentialsSecret } from '../models/KafkaSecurityConfigInputCredentialsSecret.js';
import { KafkaSecurityConfigInputTlsSecret } from '../models/KafkaSecurityConfigInputTlsSecret.js';
import { KafkaSecurityConfigTlsSecret } from '../models/KafkaSecurityConfigTlsSecret.js';
import { KafkaSourceConfig } from '../models/KafkaSourceConfig.js';
import { KafkaSourceProperties } from '../models/KafkaSourceProperties.js';
import { KafkaSourcePropertiesInput } from '../models/KafkaSourcePropertiesInput.js';
import { KafkaTopicInfo } from '../models/KafkaTopicInfo.js';
import { KafkaTopicsProbeRequest } from '../models/KafkaTopicsProbeRequest.js';
import { KafkaTopicsProbeResponse } from '../models/KafkaTopicsProbeResponse.js';
import { ListCredentialsProfilesResponse } from '../models/ListCredentialsProfilesResponse.js';
import { ListDashboardsResponse } from '../models/ListDashboardsResponse.js';
import { ListDataCatalogsResponse } from '../models/ListDataCatalogsResponse.js';
import { ListGraphsResponse } from '../models/ListGraphsResponse.js';
import { ListIngestionPipelinesResponse } from '../models/ListIngestionPipelinesResponse.js';
import { ListJobTemplatesResponse } from '../models/ListJobTemplatesResponse.js';
import { ListNotebooksResponse } from '../models/ListNotebooksResponse.js';
import { ListSavedQueriesResponse } from '../models/ListSavedQueriesResponse.js';
import { ListSparkEnginesResponse } from '../models/ListSparkEnginesResponse.js';
import { ListSparkJobsResponse } from '../models/ListSparkJobsResponse.js';
import { ListSqlEnginesResponse } from '../models/ListSqlEnginesResponse.js';
import { ListSqlQueryExecutionsResponse } from '../models/ListSqlQueryExecutionsResponse.js';
import { ListTableMaintenanceRunsRequest } from '../models/ListTableMaintenanceRunsRequest.js';
import { ListTableMaintenanceRunsResponse } from '../models/ListTableMaintenanceRunsResponse.js';
import { ListZeroEtlPoliciesResponse } from '../models/ListZeroEtlPoliciesResponse.js';
import { MaintenanceRun } from '../models/MaintenanceRun.js';
import { MetricTimeseries } from '../models/MetricTimeseries.js';
import { MetricTimeseriesPoint } from '../models/MetricTimeseriesPoint.js';
import { Notebook } from '../models/Notebook.js';
import { NotebookExecutionOutput } from '../models/NotebookExecutionOutput.js';
import { NotebookExecutionResult } from '../models/NotebookExecutionResult.js';
import { NotebookSession } from '../models/NotebookSession.js';
import { NotificationMessageMapping } from '../models/NotificationMessageMapping.js';
import { OverrideParseResult } from '../models/OverrideParseResult.js';
import { OverrideSampleExample } from '../models/OverrideSampleExample.js';
import { Pagination } from '../models/Pagination.js';
import { PaimonRestCatalogConfig } from '../models/PaimonRestCatalogConfig.js';
import { PaimonSinkProperties } from '../models/PaimonSinkProperties.js';
import { ParsedValue } from '../models/ParsedValue.js';
import { PartitionCandidate } from '../models/PartitionCandidate.js';
import { PartitionField } from '../models/PartitionField.js';
import { PathPartitionsTimestamp } from '../models/PathPartitionsTimestamp.js';
import { PathSegment } from '../models/PathSegment.js';
import { PodObservation } from '../models/PodObservation.js';
import { PollingConfig } from '../models/PollingConfig.js';
import { ProbeError } from '../models/ProbeError.js';
import { PscEndpoint } from '../models/PscEndpoint.js';
import { S3DetectPartitionsRequest } from '../models/S3DetectPartitionsRequest.js';
import { S3DetectPartitionsResponse } from '../models/S3DetectPartitionsResponse.js';
import { S3FileSampleStats } from '../models/S3FileSampleStats.js';
import { S3ListPrefixesRequest } from '../models/S3ListPrefixesRequest.js';
import { S3ListPrefixesResponse } from '../models/S3ListPrefixesResponse.js';
import { S3SampleFileRequest } from '../models/S3SampleFileRequest.js';
import { S3SampleFileResponse } from '../models/S3SampleFileResponse.js';
import { S3SampleObject } from '../models/S3SampleObject.js';
import { S3SourceProperties } from '../models/S3SourceProperties.js';
import { SaslSecretProbe } from '../models/SaslSecretProbe.js';
import { SaveNotebookContentRequest } from '../models/SaveNotebookContentRequest.js';
import { SavedQuery } from '../models/SavedQuery.js';
import { SchemaField } from '../models/SchemaField.js';
import { SchemaReference } from '../models/SchemaReference.js';
import { SchemaRegistryAuthConfig } from '../models/SchemaRegistryAuthConfig.js';
import { SchemaRegistryAuthConfigInput } from '../models/SchemaRegistryAuthConfigInput.js';
import { SchemaRegistryConfig } from '../models/SchemaRegistryConfig.js';
import { SchemaRegistryConfigInput } from '../models/SchemaRegistryConfigInput.js';
import { SchemaRegistryConnectRequest } from '../models/SchemaRegistryConnectRequest.js';
import { SchemaRegistryConnectResponse } from '../models/SchemaRegistryConnectResponse.js';
import { SchemaRegistryResolveSubjectRequest } from '../models/SchemaRegistryResolveSubjectRequest.js';
import { SchemaRegistryResolveSubjectResponse } from '../models/SchemaRegistryResolveSubjectResponse.js';
import { SchemaRegistrySchemaByIdRequest } from '../models/SchemaRegistrySchemaByIdRequest.js';
import { SchemaRegistrySchemaRequest } from '../models/SchemaRegistrySchemaRequest.js';
import { SchemaRegistrySchemaResponse } from '../models/SchemaRegistrySchemaResponse.js';
import { SchemaRegistrySubject } from '../models/SchemaRegistrySubject.js';
import { SchemaRegistrySubjectsRequest } from '../models/SchemaRegistrySubjectsRequest.js';
import { SchemaRegistrySubjectsResponse } from '../models/SchemaRegistrySubjectsResponse.js';
import { SecretRef } from '../models/SecretRef.js';
import { SecretRefAws } from '../models/SecretRefAws.js';
import { SecretRefGcp } from '../models/SecretRefGcp.js';
import { SecretRefInput } from '../models/SecretRefInput.js';
import { SecretRefInputAws } from '../models/SecretRefInputAws.js';
import { SecretRefInputGcp } from '../models/SecretRefInputGcp.js';
import { SecurityGroupRule } from '../models/SecurityGroupRule.js';
import { SortColumnSpec } from '../models/SortColumnSpec.js';
import { SourceShardByPathPartition } from '../models/SourceShardByPathPartition.js';
import { SparkEngine } from '../models/SparkEngine.js';
import { SparkJob } from '../models/SparkJob.js';
import { SparkJobRetryPolicy } from '../models/SparkJobRetryPolicy.js';
import { SparkJobSparkSubmitParams } from '../models/SparkJobSparkSubmitParams.js';
import { SparkJobStorageConfig } from '../models/SparkJobStorageConfig.js';
import { SqlEngine } from '../models/SqlEngine.js';
import { SqlQueryExecution } from '../models/SqlQueryExecution.js';
import { SqlQueryExecutionResult } from '../models/SqlQueryExecutionResult.js';
import { SqlQueryExecutionResultColumn } from '../models/SqlQueryExecutionResultColumn.js';
import { StartNotebookSessionInput } from '../models/StartNotebookSessionInput.js';
import { StartSparkJobDirectParams } from '../models/StartSparkJobDirectParams.js';
import { StartSparkJobInput } from '../models/StartSparkJobInput.js';
import { StartSparkJobTemplateParams } from '../models/StartSparkJobTemplateParams.js';
import { StartSqlQueryExecutionInput } from '../models/StartSqlQueryExecutionInput.js';
import { StorageConfig } from '../models/StorageConfig.js';
import { SubjectResolution } from '../models/SubjectResolution.js';
import { TableMaintenanceConfig } from '../models/TableMaintenanceConfig.js';
import { TableRetentionConfig } from '../models/TableRetentionConfig.js';
import { TlsSecretProbe } from '../models/TlsSecretProbe.js';
import { UpdateAwsPrivateLinkInput } from '../models/UpdateAwsPrivateLinkInput.js';
import { UpdateCredentialsProfileInput } from '../models/UpdateCredentialsProfileInput.js';
import { UpdateCredentialsProfileInputAws } from '../models/UpdateCredentialsProfileInputAws.js';
import { UpdateCredentialsProfileInputGcp } from '../models/UpdateCredentialsProfileInputGcp.js';
import { UpdateDashboardInput } from '../models/UpdateDashboardInput.js';
import { UpdateGraphInput } from '../models/UpdateGraphInput.js';
import { UpdateIngestionPipelineInput } from '../models/UpdateIngestionPipelineInput.js';
import { UpdateJobTemplateInput } from '../models/UpdateJobTemplateInput.js';
import { UpdateNotebookInput } from '../models/UpdateNotebookInput.js';
import { UpdatePscEndpointInput } from '../models/UpdatePscEndpointInput.js';
import { UpdateSavedQueryInput } from '../models/UpdateSavedQueryInput.js';
import { UpdateTableMaintenanceConfigInput } from '../models/UpdateTableMaintenanceConfigInput.js';
import { UpdateWorkspaceLoggingSettingsInput } from '../models/UpdateWorkspaceLoggingSettingsInput.js';
import { UpdateWorkspaceLoggingSettingsInputAws } from '../models/UpdateWorkspaceLoggingSettingsInputAws.js';
import { UpdateWorkspaceLoggingSettingsInputGcp } from '../models/UpdateWorkspaceLoggingSettingsInputGcp.js';
import { UpdateWorkspaceMaintenanceSettingsRequest } from '../models/UpdateWorkspaceMaintenanceSettingsRequest.js';
import { UpdateWorkspaceMetricsSettingsInput } from '../models/UpdateWorkspaceMetricsSettingsInput.js';
import { UpdateWorkspaceMetricsSettingsInputAws } from '../models/UpdateWorkspaceMetricsSettingsInputAws.js';
import { UpdateWorkspaceMetricsSettingsInputGcp } from '../models/UpdateWorkspaceMetricsSettingsInputGcp.js';
import { UpdateWorkspaceStorageAccessConfigurationInput } from '../models/UpdateWorkspaceStorageAccessConfigurationInput.js';
import { UpdateWorkspaceStorageAccessConfigurationInputAws } from '../models/UpdateWorkspaceStorageAccessConfigurationInputAws.js';
import { UpdateWorkspaceStorageAccessConfigurationInputGcp } from '../models/UpdateWorkspaceStorageAccessConfigurationInputGcp.js';
import { UpdateZeroEtlPolicyInput } from '../models/UpdateZeroEtlPolicyInput.js';
import { WarmCapacity } from '../models/WarmCapacity.js';
import { Workspace } from '../models/Workspace.js';
import { WorkspaceAllowedPrincipal } from '../models/WorkspaceAllowedPrincipal.js';
import { WorkspaceAllowedPrincipalInput } from '../models/WorkspaceAllowedPrincipalInput.js';
import { WorkspaceAws } from '../models/WorkspaceAws.js';
import { WorkspaceAwsStorageAccessConfiguration } from '../models/WorkspaceAwsStorageAccessConfiguration.js';
import { WorkspaceGcp } from '../models/WorkspaceGcp.js';
import { WorkspaceGcpStorageAccessConfiguration } from '../models/WorkspaceGcpStorageAccessConfiguration.js';
import { WorkspaceLoggingSettings } from '../models/WorkspaceLoggingSettings.js';
import { WorkspaceLoggingSettingsAws } from '../models/WorkspaceLoggingSettingsAws.js';
import { WorkspaceLoggingSettingsGcp } from '../models/WorkspaceLoggingSettingsGcp.js';
import { WorkspaceMaintenanceSettings } from '../models/WorkspaceMaintenanceSettings.js';
import { WorkspaceMetricsSettings } from '../models/WorkspaceMetricsSettings.js';
import { WorkspaceMetricsSettingsAws } from '../models/WorkspaceMetricsSettingsAws.js';
import { WorkspaceMetricsSettingsGcp } from '../models/WorkspaceMetricsSettingsGcp.js';
import { WorkspaceNetworkingSettings } from '../models/WorkspaceNetworkingSettings.js';
import { WorkspaceNetworkingSettingsAws } from '../models/WorkspaceNetworkingSettingsAws.js';
import { WorkspaceNetworkingSettingsGcp } from '../models/WorkspaceNetworkingSettingsGcp.js';
import { WorkspaceStorageAccessConfiguration } from '../models/WorkspaceStorageAccessConfiguration.js';
import { WorkspaceStorageAccessConfigurationAws } from '../models/WorkspaceStorageAccessConfigurationAws.js';
import { WorkspaceStorageAccessConfigurationGcp } from '../models/WorkspaceStorageAccessConfigurationGcp.js';
import { WorkspaceStorageAllowedCredentialsProfile } from '../models/WorkspaceStorageAllowedCredentialsProfile.js';
import { WorkspaceStorageAllowedCredentialsProfileInput } from '../models/WorkspaceStorageAllowedCredentialsProfileInput.js';
import { ZeroEtlIdentityColumnSpec } from '../models/ZeroEtlIdentityColumnSpec.js';
import { ZeroEtlPolicy } from '../models/ZeroEtlPolicy.js';
import { ZeroEtlResourceSelector } from '../models/ZeroEtlResourceSelector.js';
import { ZeroEtlRoutingPolicy } from '../models/ZeroEtlRoutingPolicy.js';
let primitives = [
    "string",
    "boolean",
    "double",
    "integer",
    "long",
    "float",
    "number",
    "any"
];
let enumsMap = new Set([
    "BatchMode",
    "BucketFileCompression",
    "BucketFileFormat",
    "BucketFileProbeRequestCloudEnum",
    "BucketFilesMode",
    "BucketNotificationTransport",
    "CompactionStrategy",
    "CreateGraphInputChartTypeEnum",
    "CreateSqlEngineInputWorkerSizeEnum",
    "DashboardGraphChartTypeEnum",
    "DataCatalogType",
    "DetectedFormatType",
    "EonSparkVersion",
    "ErrorPolicy",
    "FieldOverrideOnError",
    "FieldOverrideTargetType",
    "FileFormat",
    "IcebergRestCatalogAuthType",
    "IngestionComputeSize",
    "IngestionPipelineLastObservationHealthEnum",
    "IngestionPipelineObservationHealthEnum",
    "IngestionPipelineStatus",
    "IngestionSinkType",
    "IngestionSourceType",
    "KafkaKeyHandling",
    "KafkaMessageFormat",
    "KafkaOffsetStrategy",
    "KafkaSaslMechanism",
    "KafkaSecurityProtocol",
    "KafkaStartingOffset",
    "LooksLike",
    "MaintenanceRunStatus",
    "MaintenanceRunType",
    "NotebookExecutionOutputTypeEnum",
    "NotebookExecutionResultStatusEnum",
    "NotebookSessionStatus",
    "PaimonClusteringStrategy",
    "PaimonRestAuthMode",
    "PartitionFormat",
    "PartitionSegmentType",
    "PartitionTransform",
    "PartitionType",
    "PathPartitionsTimestampGranularity",
    "PrivateLinkStatus",
    "ProbeErrorCode",
    "S3PartitionLayout",
    "SchemaEvolutionMode",
    "SchemaRegistryAuthType",
    "SecurityGroupRuleProtocol",
    "SegmentType",
    "SortColumnSpecDirectionEnum",
    "SparkEngineStatus",
    "SparkJobStatus",
    "SqlEngineStatus",
    "SqlQueryExecutionStatus",
    "SubjectNamingStrategy",
    "UpdateGraphInputChartTypeEnum",
    "VpcPeeringStatus",
    "WorkspaceStatus",
    "WorkspaceStoragePermission",
    "ZeroEtlIdentityColumnField",
    "ZeroEtlRoutingMode",
]);
let typeMap = {
    "AnalyzeSqlQueryRequest": AnalyzeSqlQueryRequest,
    "AwsCredentialProfile": AwsCredentialProfile,
    "AwsCredentialProfileInput": AwsCredentialProfileInput,
    "AwsLoggingSettings": AwsLoggingSettings,
    "AwsLoggingSettingsInput": AwsLoggingSettingsInput,
    "AwsMetricsSettings": AwsMetricsSettings,
    "AwsMetricsSettingsInput": AwsMetricsSettingsInput,
    "AwsNetworkingSettings": AwsNetworkingSettings,
    "AwsNetworkingSettingsVpcPeering": AwsNetworkingSettingsVpcPeering,
    "AwsPrincipal": AwsPrincipal,
    "AwsPrincipalInput": AwsPrincipalInput,
    "AwsPrivateLink": AwsPrivateLink,
    "AwsSecretsManagerRef": AwsSecretsManagerRef,
    "AwsSecretsManagerRefInput": AwsSecretsManagerRefInput,
    "AwsStorageAccessConfigurationInput": AwsStorageAccessConfigurationInput,
    "AwsVpcPeering": AwsVpcPeering,
    "AwsWorkspaceInfo": AwsWorkspaceInfo,
    "BiglakeCatalogProperties": BiglakeCatalogProperties,
    "BucketFileProbeRequest": BucketFileProbeRequest,
    "BucketFileProbeResponse": BucketFileProbeResponse,
    "BucketFilesSourceProperties": BucketFilesSourceProperties,
    "BucketNotificationProbeRequest": BucketNotificationProbeRequest,
    "BucketNotificationProbeResponse": BucketNotificationProbeResponse,
    "BucketPathPartitionSpec": BucketPathPartitionSpec,
    "CatalogAccessRequest": CatalogAccessRequest,
    "CatalogAccessResponse": CatalogAccessResponse,
    "CatalogCheckNameRequest": CatalogCheckNameRequest,
    "CatalogCheckNameResponse": CatalogCheckNameResponse,
    "CatalogDatabase": CatalogDatabase,
    "CatalogListDatabasesRequest": CatalogListDatabasesRequest,
    "CatalogListDatabasesResponse": CatalogListDatabasesResponse,
    "CloudPrincipal": CloudPrincipal,
    "CloudPrincipalAws": CloudPrincipalAws,
    "CloudPrincipalGcp": CloudPrincipalGcp,
    "CloudPrincipalInput": CloudPrincipalInput,
    "CloudPrincipalInputAws": CloudPrincipalInputAws,
    "CloudPrincipalInputGcp": CloudPrincipalInputGcp,
    "Condition": Condition,
    "CreateAwsPrivateLinkInput": CreateAwsPrivateLinkInput,
    "CreateAwsVpcPeeringInput": CreateAwsVpcPeeringInput,
    "CreateCredentialsProfileInput": CreateCredentialsProfileInput,
    "CreateDashboardInput": CreateDashboardInput,
    "CreateDataCatalogInput": CreateDataCatalogInput,
    "CreateDataCatalogInputIcebergRestProperties": CreateDataCatalogInputIcebergRestProperties,
    "CreateGcpVpcPeeringInput": CreateGcpVpcPeeringInput,
    "CreateGraphInput": CreateGraphInput,
    "CreateIngestionPipelineInput": CreateIngestionPipelineInput,
    "CreateJobTemplateInput": CreateJobTemplateInput,
    "CreateNotebookInput": CreateNotebookInput,
    "CreatePscEndpointInput": CreatePscEndpointInput,
    "CreateSavedQueryInput": CreateSavedQueryInput,
    "CreateSparkEngineInput": CreateSparkEngineInput,
    "CreateSqlEngineInput": CreateSqlEngineInput,
    "CreateZeroEtlPolicyInput": CreateZeroEtlPolicyInput,
    "CredentialsProbeAssumeResponse": CredentialsProbeAssumeResponse,
    "CredentialsProbeWriteResponse": CredentialsProbeWriteResponse,
    "CredentialsProfile": CredentialsProfile,
    "CredentialsProfileAws": CredentialsProfileAws,
    "CredentialsProfileGcp": CredentialsProfileGcp,
    "Dashboard": Dashboard,
    "DashboardGraph": DashboardGraph,
    "DashboardGraphLayout": DashboardGraphLayout,
    "DashboardWithGraphs": DashboardWithGraphs,
    "DataCatalog": DataCatalog,
    "DataCatalogBiglakeProperties": DataCatalogBiglakeProperties,
    "DataCatalogGlueProperties": DataCatalogGlueProperties,
    "DataCatalogIcebergRestProperties": DataCatalogIcebergRestProperties,
    "DetectedFormat": DetectedFormat,
    "ExecuteNotebookCodeInput": ExecuteNotebookCodeInput,
    "FieldOverride": FieldOverride,
    "FlinkDeploymentObservation": FlinkDeploymentObservation,
    "GcpCredentialProfile": GcpCredentialProfile,
    "GcpCredentialProfileInput": GcpCredentialProfileInput,
    "GcpLoggingSettings": GcpLoggingSettings,
    "GcpLoggingSettingsInput": GcpLoggingSettingsInput,
    "GcpMetricsSettings": GcpMetricsSettings,
    "GcpMetricsSettingsInput": GcpMetricsSettingsInput,
    "GcpNetworkingSettings": GcpNetworkingSettings,
    "GcpNetworkingSettingsVpcPeering": GcpNetworkingSettingsVpcPeering,
    "GcpPrincipal": GcpPrincipal,
    "GcpPrincipalInput": GcpPrincipalInput,
    "GcpSecretManagerRef": GcpSecretManagerRef,
    "GcpSecretManagerRefInput": GcpSecretManagerRefInput,
    "GcpStorageAccessConfigurationInput": GcpStorageAccessConfigurationInput,
    "GcpVpcPeering": GcpVpcPeering,
    "GcpWorkspaceInfo": GcpWorkspaceInfo,
    "GcsListPrefixesRequest": GcsListPrefixesRequest,
    "GcsListPrefixesResponse": GcsListPrefixesResponse,
    "GcsSampleObject": GcsSampleObject,
    "GcsSourceProperties": GcsSourceProperties,
    "GetNotebookContent200Response": GetNotebookContent200Response,
    "GlueCatalogProperties": GlueCatalogProperties,
    "IcebergCompactionConfig": IcebergCompactionConfig,
    "IcebergRestCatalogProperties": IcebergRestCatalogProperties,
    "IcebergRestCatalogPropertiesCredentialsSecret": IcebergRestCatalogPropertiesCredentialsSecret,
    "IcebergRestCatalogPropertiesInput": IcebergRestCatalogPropertiesInput,
    "IcebergRestCatalogPropertiesInputCredentialsSecret": IcebergRestCatalogPropertiesInputCredentialsSecret,
    "IcebergSinkProperties": IcebergSinkProperties,
    "IngestionPipeline": IngestionPipeline,
    "IngestionPipelineLastObservation": IngestionPipelineLastObservation,
    "IngestionPipelineMetrics": IngestionPipelineMetrics,
    "IngestionPipelineMetricsRange": IngestionPipelineMetricsRange,
    "IngestionPipelineObservation": IngestionPipelineObservation,
    "IngestionPipelineObservationFlinkDeployment": IngestionPipelineObservationFlinkDeployment,
    "JobTemplate": JobTemplate,
    "JobTemplateRetryPolicy": JobTemplateRetryPolicy,
    "JsonPathSample": JsonPathSample,
    "K8sEventObservation": K8sEventObservation,
    "KafkaBatchConfig": KafkaBatchConfig,
    "KafkaConnectProbeRequest": KafkaConnectProbeRequest,
    "KafkaConnectProbeResponse": KafkaConnectProbeResponse,
    "KafkaErrorHandlingConfig": KafkaErrorHandlingConfig,
    "KafkaInferSchemaRequest": KafkaInferSchemaRequest,
    "KafkaInferSchemaResponse": KafkaInferSchemaResponse,
    "KafkaMessageSample": KafkaMessageSample,
    "KafkaPartitioningConfig": KafkaPartitioningConfig,
    "KafkaSampleProbeRequest": KafkaSampleProbeRequest,
    "KafkaSampleProbeResponse": KafkaSampleProbeResponse,
    "KafkaSchemaOverridesConfig": KafkaSchemaOverridesConfig,
    "KafkaSecretProbeRequest": KafkaSecretProbeRequest,
    "KafkaSecretProbeResponse": KafkaSecretProbeResponse,
    "KafkaSecurityConfig": KafkaSecurityConfig,
    "KafkaSecurityConfigCredentialsSecret": KafkaSecurityConfigCredentialsSecret,
    "KafkaSecurityConfigInput": KafkaSecurityConfigInput,
    "KafkaSecurityConfigInputCredentialsSecret": KafkaSecurityConfigInputCredentialsSecret,
    "KafkaSecurityConfigInputTlsSecret": KafkaSecurityConfigInputTlsSecret,
    "KafkaSecurityConfigTlsSecret": KafkaSecurityConfigTlsSecret,
    "KafkaSourceConfig": KafkaSourceConfig,
    "KafkaSourceProperties": KafkaSourceProperties,
    "KafkaSourcePropertiesInput": KafkaSourcePropertiesInput,
    "KafkaTopicInfo": KafkaTopicInfo,
    "KafkaTopicsProbeRequest": KafkaTopicsProbeRequest,
    "KafkaTopicsProbeResponse": KafkaTopicsProbeResponse,
    "ListCredentialsProfilesResponse": ListCredentialsProfilesResponse,
    "ListDashboardsResponse": ListDashboardsResponse,
    "ListDataCatalogsResponse": ListDataCatalogsResponse,
    "ListGraphsResponse": ListGraphsResponse,
    "ListIngestionPipelinesResponse": ListIngestionPipelinesResponse,
    "ListJobTemplatesResponse": ListJobTemplatesResponse,
    "ListNotebooksResponse": ListNotebooksResponse,
    "ListSavedQueriesResponse": ListSavedQueriesResponse,
    "ListSparkEnginesResponse": ListSparkEnginesResponse,
    "ListSparkJobsResponse": ListSparkJobsResponse,
    "ListSqlEnginesResponse": ListSqlEnginesResponse,
    "ListSqlQueryExecutionsResponse": ListSqlQueryExecutionsResponse,
    "ListTableMaintenanceRunsRequest": ListTableMaintenanceRunsRequest,
    "ListTableMaintenanceRunsResponse": ListTableMaintenanceRunsResponse,
    "ListZeroEtlPoliciesResponse": ListZeroEtlPoliciesResponse,
    "MaintenanceRun": MaintenanceRun,
    "MetricTimeseries": MetricTimeseries,
    "MetricTimeseriesPoint": MetricTimeseriesPoint,
    "Notebook": Notebook,
    "NotebookExecutionOutput": NotebookExecutionOutput,
    "NotebookExecutionResult": NotebookExecutionResult,
    "NotebookSession": NotebookSession,
    "NotificationMessageMapping": NotificationMessageMapping,
    "OverrideParseResult": OverrideParseResult,
    "OverrideSampleExample": OverrideSampleExample,
    "Pagination": Pagination,
    "PaimonRestCatalogConfig": PaimonRestCatalogConfig,
    "PaimonSinkProperties": PaimonSinkProperties,
    "ParsedValue": ParsedValue,
    "PartitionCandidate": PartitionCandidate,
    "PartitionField": PartitionField,
    "PathPartitionsTimestamp": PathPartitionsTimestamp,
    "PathSegment": PathSegment,
    "PodObservation": PodObservation,
    "PollingConfig": PollingConfig,
    "ProbeError": ProbeError,
    "PscEndpoint": PscEndpoint,
    "S3DetectPartitionsRequest": S3DetectPartitionsRequest,
    "S3DetectPartitionsResponse": S3DetectPartitionsResponse,
    "S3FileSampleStats": S3FileSampleStats,
    "S3ListPrefixesRequest": S3ListPrefixesRequest,
    "S3ListPrefixesResponse": S3ListPrefixesResponse,
    "S3SampleFileRequest": S3SampleFileRequest,
    "S3SampleFileResponse": S3SampleFileResponse,
    "S3SampleObject": S3SampleObject,
    "S3SourceProperties": S3SourceProperties,
    "SaslSecretProbe": SaslSecretProbe,
    "SaveNotebookContentRequest": SaveNotebookContentRequest,
    "SavedQuery": SavedQuery,
    "SchemaField": SchemaField,
    "SchemaReference": SchemaReference,
    "SchemaRegistryAuthConfig": SchemaRegistryAuthConfig,
    "SchemaRegistryAuthConfigInput": SchemaRegistryAuthConfigInput,
    "SchemaRegistryConfig": SchemaRegistryConfig,
    "SchemaRegistryConfigInput": SchemaRegistryConfigInput,
    "SchemaRegistryConnectRequest": SchemaRegistryConnectRequest,
    "SchemaRegistryConnectResponse": SchemaRegistryConnectResponse,
    "SchemaRegistryResolveSubjectRequest": SchemaRegistryResolveSubjectRequest,
    "SchemaRegistryResolveSubjectResponse": SchemaRegistryResolveSubjectResponse,
    "SchemaRegistrySchemaByIdRequest": SchemaRegistrySchemaByIdRequest,
    "SchemaRegistrySchemaRequest": SchemaRegistrySchemaRequest,
    "SchemaRegistrySchemaResponse": SchemaRegistrySchemaResponse,
    "SchemaRegistrySubject": SchemaRegistrySubject,
    "SchemaRegistrySubjectsRequest": SchemaRegistrySubjectsRequest,
    "SchemaRegistrySubjectsResponse": SchemaRegistrySubjectsResponse,
    "SecretRef": SecretRef,
    "SecretRefAws": SecretRefAws,
    "SecretRefGcp": SecretRefGcp,
    "SecretRefInput": SecretRefInput,
    "SecretRefInputAws": SecretRefInputAws,
    "SecretRefInputGcp": SecretRefInputGcp,
    "SecurityGroupRule": SecurityGroupRule,
    "SortColumnSpec": SortColumnSpec,
    "SourceShardByPathPartition": SourceShardByPathPartition,
    "SparkEngine": SparkEngine,
    "SparkJob": SparkJob,
    "SparkJobRetryPolicy": SparkJobRetryPolicy,
    "SparkJobSparkSubmitParams": SparkJobSparkSubmitParams,
    "SparkJobStorageConfig": SparkJobStorageConfig,
    "SqlEngine": SqlEngine,
    "SqlQueryExecution": SqlQueryExecution,
    "SqlQueryExecutionResult": SqlQueryExecutionResult,
    "SqlQueryExecutionResultColumn": SqlQueryExecutionResultColumn,
    "StartNotebookSessionInput": StartNotebookSessionInput,
    "StartSparkJobDirectParams": StartSparkJobDirectParams,
    "StartSparkJobInput": StartSparkJobInput,
    "StartSparkJobTemplateParams": StartSparkJobTemplateParams,
    "StartSqlQueryExecutionInput": StartSqlQueryExecutionInput,
    "StorageConfig": StorageConfig,
    "SubjectResolution": SubjectResolution,
    "TableMaintenanceConfig": TableMaintenanceConfig,
    "TableRetentionConfig": TableRetentionConfig,
    "TlsSecretProbe": TlsSecretProbe,
    "UpdateAwsPrivateLinkInput": UpdateAwsPrivateLinkInput,
    "UpdateCredentialsProfileInput": UpdateCredentialsProfileInput,
    "UpdateCredentialsProfileInputAws": UpdateCredentialsProfileInputAws,
    "UpdateCredentialsProfileInputGcp": UpdateCredentialsProfileInputGcp,
    "UpdateDashboardInput": UpdateDashboardInput,
    "UpdateGraphInput": UpdateGraphInput,
    "UpdateIngestionPipelineInput": UpdateIngestionPipelineInput,
    "UpdateJobTemplateInput": UpdateJobTemplateInput,
    "UpdateNotebookInput": UpdateNotebookInput,
    "UpdatePscEndpointInput": UpdatePscEndpointInput,
    "UpdateSavedQueryInput": UpdateSavedQueryInput,
    "UpdateTableMaintenanceConfigInput": UpdateTableMaintenanceConfigInput,
    "UpdateWorkspaceLoggingSettingsInput": UpdateWorkspaceLoggingSettingsInput,
    "UpdateWorkspaceLoggingSettingsInputAws": UpdateWorkspaceLoggingSettingsInputAws,
    "UpdateWorkspaceLoggingSettingsInputGcp": UpdateWorkspaceLoggingSettingsInputGcp,
    "UpdateWorkspaceMaintenanceSettingsRequest": UpdateWorkspaceMaintenanceSettingsRequest,
    "UpdateWorkspaceMetricsSettingsInput": UpdateWorkspaceMetricsSettingsInput,
    "UpdateWorkspaceMetricsSettingsInputAws": UpdateWorkspaceMetricsSettingsInputAws,
    "UpdateWorkspaceMetricsSettingsInputGcp": UpdateWorkspaceMetricsSettingsInputGcp,
    "UpdateWorkspaceStorageAccessConfigurationInput": UpdateWorkspaceStorageAccessConfigurationInput,
    "UpdateWorkspaceStorageAccessConfigurationInputAws": UpdateWorkspaceStorageAccessConfigurationInputAws,
    "UpdateWorkspaceStorageAccessConfigurationInputGcp": UpdateWorkspaceStorageAccessConfigurationInputGcp,
    "UpdateZeroEtlPolicyInput": UpdateZeroEtlPolicyInput,
    "WarmCapacity": WarmCapacity,
    "Workspace": Workspace,
    "WorkspaceAllowedPrincipal": WorkspaceAllowedPrincipal,
    "WorkspaceAllowedPrincipalInput": WorkspaceAllowedPrincipalInput,
    "WorkspaceAws": WorkspaceAws,
    "WorkspaceAwsStorageAccessConfiguration": WorkspaceAwsStorageAccessConfiguration,
    "WorkspaceGcp": WorkspaceGcp,
    "WorkspaceGcpStorageAccessConfiguration": WorkspaceGcpStorageAccessConfiguration,
    "WorkspaceLoggingSettings": WorkspaceLoggingSettings,
    "WorkspaceLoggingSettingsAws": WorkspaceLoggingSettingsAws,
    "WorkspaceLoggingSettingsGcp": WorkspaceLoggingSettingsGcp,
    "WorkspaceMaintenanceSettings": WorkspaceMaintenanceSettings,
    "WorkspaceMetricsSettings": WorkspaceMetricsSettings,
    "WorkspaceMetricsSettingsAws": WorkspaceMetricsSettingsAws,
    "WorkspaceMetricsSettingsGcp": WorkspaceMetricsSettingsGcp,
    "WorkspaceNetworkingSettings": WorkspaceNetworkingSettings,
    "WorkspaceNetworkingSettingsAws": WorkspaceNetworkingSettingsAws,
    "WorkspaceNetworkingSettingsGcp": WorkspaceNetworkingSettingsGcp,
    "WorkspaceStorageAccessConfiguration": WorkspaceStorageAccessConfiguration,
    "WorkspaceStorageAccessConfigurationAws": WorkspaceStorageAccessConfigurationAws,
    "WorkspaceStorageAccessConfigurationGcp": WorkspaceStorageAccessConfigurationGcp,
    "WorkspaceStorageAllowedCredentialsProfile": WorkspaceStorageAllowedCredentialsProfile,
    "WorkspaceStorageAllowedCredentialsProfileInput": WorkspaceStorageAllowedCredentialsProfileInput,
    "ZeroEtlIdentityColumnSpec": ZeroEtlIdentityColumnSpec,
    "ZeroEtlPolicy": ZeroEtlPolicy,
    "ZeroEtlResourceSelector": ZeroEtlResourceSelector,
    "ZeroEtlRoutingPolicy": ZeroEtlRoutingPolicy,
};
export class ObjectSerializer {
    static findCorrectType(data, expectedType) {
        if (data == undefined) {
            return expectedType;
        }
        else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
            return expectedType;
        }
        else if (expectedType === "Date") {
            return expectedType;
        }
        else {
            if (enumsMap.has(expectedType)) {
                return expectedType;
            }
            if (!typeMap[expectedType]) {
                return expectedType;
            }
            let discriminatorProperty = typeMap[expectedType].discriminator;
            if (discriminatorProperty == null) {
                return expectedType;
            }
            else {
                if (data[discriminatorProperty]) {
                    var discriminatorType = data[discriminatorProperty];
                    if (typeMap[discriminatorType]) {
                        return discriminatorType;
                    }
                    else {
                        return expectedType;
                    }
                }
                else {
                    return expectedType;
                }
            }
        }
    }
    static serialize(data, type, format) {
        if (data === undefined || data === null || primitives.includes(type.toLowerCase())) {
            return data;
        }
        else if (type.startsWith("Array<", 0)) {
            let subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.serialize(date, subType, format));
            }
            return transformedData;
        }
        else if (type === "Date") {
            if (format == "date") {
                let month = data.getMonth() + 1;
                month = month < 10 ? "0" + month.toString() : month.toString();
                let day = data.getDate();
                day = day < 10 ? "0" + day.toString() : day.toString();
                return data.getFullYear() + "-" + month + "-" + day;
            }
            else {
                return data.toISOString();
            }
        }
        else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            type = this.findCorrectType(data, type);
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            let instance = {};
            for (let attributeType of attributeTypes) {
                instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type, attributeType.format);
            }
            return instance;
        }
    }
    static deserialize(data, type, format) {
        type = ObjectSerializer.findCorrectType(data, type);
        if (data == undefined) {
            return data;
        }
        else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        }
        else if (type.lastIndexOf("Array<", 0) === 0) {
            let subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.deserialize(date, subType, format));
            }
            return transformedData;
        }
        else if (type === "Date") {
            return new Date(data);
        }
        else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            let instance = new typeMap[type]();
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            for (let attributeType of attributeTypes) {
                let value = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type, attributeType.format);
                if (value !== undefined) {
                    instance[attributeType.name] = value;
                }
            }
            return instance;
        }
    }
    static getPreferredMediaType(mediaTypes) {
        return "application/json";
    }
}
